import { Box, IconButton, SvgIcon, Tooltip, Zoom, useTheme } from "@mui/material";

export default function ActionButtons(props) {
  const { content, size = "small" } = props;
  
  const theme = useTheme();
  const { palette = {} } = theme;
  const { primary = {}, success = {} } = palette;
  
  const navyColor = primary?.main || "#002843";
  const greenColor = success?.main || "#A0C46D";

  // Size configurations
  const sizeConfig = {
    small: {
      iconSize: "18px",
      buttonSize: "32px",
      padding: "6px",
    },
    medium: {
      iconSize: "20px",
      buttonSize: "36px",
      padding: "8px",
    },
    large: {
      iconSize: "22px",
      buttonSize: "40px",
      padding: "9px",
    },
  };

  const currentSize = sizeConfig[size] || sizeConfig.small;

  // Color variants for different action types
  const getActionColor = (title) => {
    const lowerTitle = title?.toLowerCase() || "";
    if (lowerTitle.includes("delete") || lowerTitle.includes("remove")) {
      return {
        color: "#ef4444",
        bgHover: "rgba(239, 68, 68, 0.1)",
        bgActive: "rgba(239, 68, 68, 0.15)",
      };
    }
    if (lowerTitle.includes("edit") || lowerTitle.includes("update")) {
      return {
        color: "#3b82f6",
        bgHover: "rgba(59, 130, 246, 0.1)",
        bgActive: "rgba(59, 130, 246, 0.15)",
      };
    }
    if (lowerTitle.includes("view") || lowerTitle.includes("facility") || lowerTitle.includes("zone") || lowerTitle.includes("layout") || lowerTitle.includes("configure")) {
      return {
        color: greenColor,
        bgHover: "rgba(160, 196, 109, 0.12)",
        bgActive: "rgba(160, 196, 109, 0.18)",
      };
    }
    // Default
    return {
      color: "#64748b",
      bgHover: "rgba(100, 116, 139, 0.1)",
      bgActive: "rgba(100, 116, 139, 0.15)",
    };
  };

  const iconContent = content.map((element, index) => {
    const { action, disabled = false, icon, title } = element;
    const colors = getActionColor(title);

    return (
      <Tooltip
        key={index}
        title={title}
        arrow
        placement="top"
        TransitionComponent={Zoom}
        enterDelay={300}
        slotProps={{
          tooltip: {
            sx: {
              backgroundColor: navyColor,
              color: "#ffffff",
              fontSize: "0.75rem",
              fontWeight: 500,
              padding: "6px 12px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            },
          },
          arrow: {
            sx: {
              color: navyColor,
            },
          },
        }}
      >
        <IconButton
          aria-label={title}
          disabled={disabled}
          onClick={action}
          sx={{
            width: currentSize.buttonSize,
            height: currentSize.buttonSize,
            padding: currentSize.padding,
            borderRadius: "10px",
            color: disabled ? "#cbd5e1" : colors.color,
            backgroundColor: "transparent",
            border: "1px solid transparent",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            "&:hover": {
              backgroundColor: colors.bgHover,
              borderColor: `${colors.color}30`,
              transform: "translateY(-2px)",
              boxShadow: `0 4px 12px ${colors.color}25`,
            },
            "&:active": {
              backgroundColor: colors.bgActive,
              transform: "translateY(0)",
              boxShadow: "none",
            },
            "&.Mui-disabled": {
              color: "#cbd5e1",
              backgroundColor: "transparent",
            },
          }}
        >
          <SvgIcon 
            sx={{ 
              width: currentSize.iconSize, 
              height: currentSize.iconSize,
              transition: "transform 0.2s ease-in-out",
            }}
          >
            {icon}
          </SvgIcon>
        </IconButton>
      </Tooltip>
    );
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      {iconContent}
    </Box>
  );
}
